// /**
//  * Reference: 
//  * https://alexatnet.com/model-view-controller-mvc-in-javascript/
//  * https://betterprogramming.pub/how-to-create-your-own-event-emitter-in-javascript-fbd5db2447c4
//  */
export class IllumioEventEmitter {
    #isDebug = true;

    constructor() {
        this._events = {};
    }

    on(evt, listener) {
        (this._events[evt] || (this._events[evt] = [])).push(listener);
        return this;
    }

    emit(evt, arg) {
        (this._events[evt] || []).slice().forEach(lsn => lsn(arg));
    }

    isDebug() {
        return this.#isDebug;
    }

    setDebug(isDebug) {
        this.isDebug = isDebug;
    }
}
